import { render, staticRenderFns } from "./AssessmentCardProgress.vue?vue&type=template&id=36fe8992&"
import script from "./AssessmentCardProgress.vue?vue&type=script&lang=js&"
export * from "./AssessmentCardProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports